// test2167
(2167 && 0);
